/* eslint-disable no-unused-vars */
import { Component, OnInit } from '@angular/core';
import { BtnType } from '@core';
import { SpProgram } from '@session';
import { SpProgramService } from '@session/sp-program.service';

@Component({
  selector: 'sp-register-terms',
  templateUrl: './registration-terms.html'
})

export class RegistrationTermsComponent implements OnInit {
  btn = BtnType;
  program: SpProgram;
  constructor(private spProgramService: SpProgramService) {}
  ngOnInit(): void {
    this.spProgramService
      .loadProgramFromCurrentLocationAndPartnerCode()
      .subscribe((s) => (this.program = s));
    window.scrollTo(0, 0);
  }
  
  get disabled() {
    return false;
  }

  continue() {
    if (window.history.length > 1) {
      window.history.back();
    } else if (document.referrer.includes('/register/get-start')) {
      window.location.href = '/register/get-start';
    } else {
      window.location.pathname = '/';
    }
  }
}